<div class="workflow-dropdown" data-testid="dappa-api-dropdown">
  <button
    class="workflow-selector-btn"
    (click)="toggleDropdown()"
    [attr.aria-expanded]="isOpen()"
    [attr.aria-haspopup]="true"
  >
    <span class="workflow-text">{{ label() }}</span>
    <mat-icon class="dropdown-arrow" [class.open]="isOpen()">arrow_drop_down</mat-icon>
  </button>

  <div
    class="dropdown-menu"
    [class.open]="isOpen()"
    [attr.aria-hidden]="!isOpen()"
    [style.display]="isOpen() ? 'block' : 'none'"
    role="menu"
  >
    <div
      class="dropdown-item workflow-item"
      [class.selected]="selectedApiId() === undefined"
      (click)="selectAll()"
      (keydown)="isActivationKey($event) && selectAll()"
      role="menuitem"
      tabindex="0"
      data-testid="dappa-api-dropdown-all"
    >
      <div class="workflow-content">
        <div class="workflow-info">
          <span class="workflow-name">All APIs</span>
        </div>
        <div class="workflow-icons">
          @if (selectedApiId() === undefined) {
            <mat-icon class="check-icon">check</mat-icon>
          }
        </div>
      </div>
    </div>

    <div class="dropdown-divider"></div>

    @if (store.hasError()) {
      <div class="dropdown-item no-workflows" role="alert" data-testid="dappa-api-dropdown-error">
        <span class="no-workflows-text">Failed to load APIs.</span>
      </div>
      <div
        class="dropdown-item workflow-item"
        (click)="store.reload()"
        (keydown)="isActivationKey($event) && store.reload()"
        role="menuitem"
        tabindex="0"
        data-testid="dappa-api-dropdown-retry"
      >
        <div class="workflow-content">
          <div class="workflow-info">
            <span class="workflow-name">Retry</span>
          </div>
        </div>
      </div>
    } @else {
      @for (api of store.apis(); track api.apiId) {
        <div
          class="dropdown-item workflow-item"
          [class.selected]="api.apiId === selectedApiId()"
          (click)="selectApi(api)"
          (keydown)="isActivationKey($event) && selectApi(api)"
          role="menuitem"
          tabindex="0"
        >
          <div class="workflow-content">
            <div class="workflow-info">
              <span class="workflow-name">{{ api.name }}</span>
              <span class="workflow-timestamp">/dappa/{{ api.normalizedName }}/</span>
            </div>
            <div class="workflow-icons">
              @if (api.apiId === selectedApiId()) {
                <mat-icon class="check-icon">check</mat-icon>
              }
            </div>
          </div>
        </div>
      } @empty {
        <div class="dropdown-item no-workflows">
          <span class="no-workflows-text">No APIs in this version</span>
        </div>
      }
    }
  </div>

  @if (isOpen()) {
    <div class="dropdown-backdrop" (click)="closeDropdown()" (keydown)="isActivationKey($event) && closeDropdown()" tabindex="0"></div>
  }
</div>
